var annualReportNavigation = require('../mixins/annual-report-navigation')

module.exports = Em.Controller.extend(annualReportNavigation, {
    isLoading: false,

    year: function() {
        var currentYear = this.get('model.commitment.year')

        return {
            current: currentYear,
            prev: currentYear - 1
        }
    }.property('model.commitment.year'),

    intangiblesIsInvalid: function() {
        return !this.get('fixedAssets.validates')
    }.property('fixedAssets'),

    isButtonDisabled: function() {
        return this.get('intangiblesIsInvalid') || this.get('isLoading')
    }.property('intangiblesIsInvalid', 'isLoading'),

    actions: {
        didClickNext: function() {
            var self = this
            self.set('isLoading', true)

            var promise = this.isActiveStepCompleted()
                ? Em.RSVP.Promise.resolve()
                : this.get('annualReport').putSteps(this.get('model.commitment.year'), { intangible_fixed_assets: true })

            promise.then(function() {
                self.send('navigateToNextStep')
            }).catch(function() {
                self.set('isLoading', false)
            })
        },

        updateAssets: function(res) {
            this.set('fixedAssets', res.data.fixedAssetsMovements.intangible)
        }
    }
})
